export default {
    setLanguage(context, languageCode) {
        // Validate language code
        const availableLanguages = context.getters.getAvailableLanguages;
        const isValidLanguage = availableLanguages.some(lang => lang.code === languageCode);
        
        if (!isValidLanguage) {
            console.warn(`Language ${languageCode} is not available. Falling back to default.`);
            languageCode = 'en';
        }
        
        // Save to localStorage
        localStorage.setItem('app_language', languageCode);
        
        // Update state
        context.commit('setLanguage', languageCode);
        
        // Update i18n locale (i18n is set in main.js and watched there)
        // The watcher in main.js will handle the i18n update
    },
    
    initializeLanguage(context) {
        // Try to load from localStorage
        const savedLanguage = localStorage.getItem('app_language');
        
        const isAvailable = context.getters.getAvailableLanguages.some(lang => lang.code === savedLanguage);

        if (savedLanguage && isAvailable) {
            context.dispatch('setLanguage', savedLanguage);
        } else {
            // Default to English
            context.dispatch('setLanguage', 'en');
        }
    }
};

